import { PageHeader as PH, IPageHeaderProps } from '@fcamna/react-library';
import './Header.scss';
import { TSectionAemProp } from '../../model/AemDataProps';
import { htmlReactParser } from '../../utils/htmlReactParser';

export interface HeaderProps extends IPageHeaderProps {
  className?: string;
  aemHeaderProps?: TSectionAemProp;
}

export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | undefined;
export type HeadingSize = 'extraLarge' | 'large' | 'medium' | undefined;

/**
 * use this component only as Header of the page, at the top.
 * It works for section of the page level but use FeatureText component instead.
 * */
export function PageHeader({
  aemHeaderProps,
  className,
  ...props
}: Omit<HeaderProps, 'titleProp'>) {
  const title = htmlReactParser(aemHeaderProps?.heading ?? '');
  const description = aemHeaderProps?.text;
  const klass = `center-align-header center-align-content ${className}`;
  return (
    <div className="bbas-header">
      <PH
        titleProp={{ title: title, headingLevel: 'h1', size: 'extraLarge' }}
        description={htmlReactParser(description)}
        className={klass}
        bottomStroke={false}
        hideBackground
        {...props}
      />
    </div>
  );
}
